exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .lang-select-btn{height:20px;width:20px}#wacg-wrapper .lang-select-btn svg{height:20px;width:20px;fill:#333}", ""]);

// exports
